import { render, staticRenderFns } from "./ArvoreProdutosListLevel.vue?vue&type=template&id=b649d684"
import script from "./ArvoreProdutosListLevel.vue?vue&type=script&lang=js"
export * from "./ArvoreProdutosListLevel.vue?vue&type=script&lang=js"
import style0 from "./ArvoreProdutosListLevel.vue?vue&type=style&index=0&id=b649d684&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports